import { select, call, takeLatest, put } from 'redux-saga/effects';

import { BonusActions } from '../constants';
import { BonusApi } from 'src/services/end-points';
import { StoreState } from '../reducers';
import { PaginationService } from '../../services/api-handlers/pagination';
import {
    GetBonusAction,
    GetBonusesAction,
    GenerateBonusAction,
    GetExigentBonusStatusAction,
    getBonusesCsv,
    getBonuses,
} from '../actions/bonus-actions';
import {
    handleError,
    resolveApiCall,
    ResolverApiFailure,
    ResolverApiSuccess,
} from '../../services/api-handlers/api-resolver';
import { push } from 'connected-react-router';
import Router from '../../navigation/router';
import routes from '../../navigation/routes';
import { groupDataToCsv } from '../../helpers/bonus/groupCsv';
import { exportToCsv } from '../../services/exports/csv';
import sortingService from 'src/services/sorting';
import { toast } from 'react-toastify';
import _ from 'lodash';

function* handleFetchBonuses(action: GetBonusesAction) {
    const oldData = yield select((state: StoreState) => state.bonuses.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;

    let filterProps: any = { ...filters };

    if (filterProps?.createdAt) {
        filterProps = {
            ...filters,
            ...filterProps?.createdAt,
        };
        delete filterProps.createdAt;
    }
    let sortObj = { ...sorting };
    if (_.isEmpty(sortObj)) {
        sortObj = { createdAt: 'asc' };
    }
    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        BonusApi.getBonuses({
            ...filterProps,
            ...sortingService.makeOrderSymfony(sortObj),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchBonusesCsv(action: GetBonusesAction): any {
    const { filters, sorting, itemsPerPage } = action.payload;
    let page: number = action?.payload?.page ? +action.payload.page : 1;
    let filterProps: any = { ...filters };

    if (filterProps?.createdAt) {
        filterProps = {
            ...filters,
            ...filterProps?.createdAt,
        };
        delete filterProps.createdAt;
    }
    let sortObj = { ...sorting };
    if (_.isEmpty(sortObj)) {
        sortObj = { createdAt: 'desc' };
    }
    yield resolveApiCall(
        action,
        () =>
            BonusApi.getBonuses({
                ...filterProps,
                ...sortingService.makeOrderSymfony(sortObj),
                page,
                itemsPerPage: 5000,
                pagination: itemsPerPage === -1 ? 0 : 1,
            }),
        function* (data) {
            if (data.payload.length === 5000) {
                yield put(
                    getBonusesCsv({
                        filters,
                        page: ++page,
                        sorting,
                        itemsPerPage: 5000,
                        all: action.all ? [...action.all, ...data.payload] : [...data.payload],
                    }),
                );
            } else {
                const dataAll = action.all ? [...action.all, ...data.payload] : [...data.payload];
                if (action.all) {
                    const groupCsv = groupDataToCsv(dataAll);
                    exportToCsv('bonuses.csv', groupCsv);
                } else {
                    const groupCsvData = groupDataToCsv(data.payload);
                    exportToCsv('bonuses.csv', groupCsvData);
                }
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
            }
            handleError(result);
        },
    );
}

function* handleFetchBonus(action: GetBonusAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => BonusApi.getBonus(id));
}

function* handleGenerateBonus(action: GenerateBonusAction) {
    const { payload } = action;
    const { data, callbacks } = payload;
    yield resolveApiCall(
        action,
        () => BonusApi.generateBonus(data),
        function* (dataResponse: ResolverApiSuccess) {
            toast.success(`Bonus list was updated.`);
            yield call(callbacks.resolve);
            if (data.month) {
                yield put(
                    getBonuses({
                        filters: {
                            'provider.id': data?.provider,
                            'createdAt[before]': data.month.monthEnd,
                            'createdAt[after]': data.month.monthStart,
                        },
                        itemsPerPage: 1200,
                        page: 1,
                    }),
                );
            } else {
                //if (!id) {    }
                yield put(push(Router.generate(routes.ADMIN_WORKS_LIST)));
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handleFetchExigentBonusStatus(action: GetExigentBonusStatusAction) {
    const {
        payload: { providerId },
    } = action;

    yield resolveApiCall(action, () => BonusApi.getExigentBonusStatus(providerId));
}

export default function* () {
    yield takeLatest(BonusActions.FETCH_BONUSES, handleFetchBonuses);
    yield takeLatest(BonusActions.FETCH_BONUS, handleFetchBonus);
    yield takeLatest(BonusActions.GENERATE_BONUS, handleGenerateBonus);
    yield takeLatest(BonusActions.FETCH_BONUSES_CSV, handleFetchBonusesCsv);
    yield takeLatest(BonusActions.FETCH_EXIGENT_BONUS_STATUS, handleFetchExigentBonusStatus);
}
